













































import { Component, Vue, Emit, Prop, Ref } from "vue-property-decorator";
import FormValidations from "@/helpers/validations";
import { cloneDeep } from "lodash";
import Definition from "@/models/definition";
import type { Form } from "@/models/general";
import DefinitionValues from "./DefinitionValues.vue";

@Component({
  components: { DefinitionValues },
})
export default class DefinitionForm extends Vue {
  @Prop({ default: "definitions.new" }) title!: string;
  @Prop() initialData?: Definition;
  @Ref("form") readonly form!: Form;
  @Prop({ default: "create" }) readonly mode!: "edit";

  model: Definition = new Definition();
  formValidations = new FormValidations();
  loading = false;

  created(): void {
    if (this.initialData) this.model = cloneDeep(this.initialData);
  }

  validate(): void {
    const validForm = this.form.validate();
    validForm ? this.save() : null;
  }

  @Emit()
  save(): Definition {
    return this.model;
  }
  @Emit()
  cancel(): null {
    return null;
  }
}
